<template>
  <div>
    <vx-card>
      <div class="flex pb-5 justify-between items-center">
        <!-- description -->
        <div>
          {{ description }}
        </div>

        <!-- buttons -->
        <div class="flex gap-2">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
            @click="onPressedActiveReceiveManyModal()"
            v-if="visibilityReceiveMany()"
          >
            รับงานแบบกำหนดเอง
          </vs-button>

          <vs-button
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-x-circle"
            @click="onPressedUnReceivedAllCallHistory()"
            v-if="visibilityUnReceivedAll()"
          >
            ยกเลิกรับงานทั้งหมด
          </vs-button>

          <vs-button
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-x-circle"
            @click="onPressedUnReceiveCallHistoryByUserId()"
            v-if="visibilityUnReceiveByUserId()"
          >
            ยกเลิกรับงานทั้งหมดของคุณ
          </vs-button>
        </div>
      </div>

      <vs-table :data="_notificationContractsCallEx">

        <template slot="thead">
          <vs-th>{{ $t("sections.accounting.dataForm.no") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.loan.agingNumber") }}</vs-th>
          <vs-th>ยอดเรียกเก็บค้างชำระ</vs-th>
          <vs-th>ยอดเรียกเก็บปัจจุบัน</vs-th>
          <vs-th>ต่าธรรมเนียม</vs-th>
          <vs-th>เบี้ยปรับ</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index"
                 v-for="({id, contractNo, contractSeq, contractName, loan, callHistoriesReceivedBy}, index) in data">
            <vs-td>
              {{ index + 1 }}
            </vs-td>
            <vs-td>
              <router-link :to="{ name: 'accounting-contract-detail', params: {id}}"> {{ contractNo }}
                <b><u>{{ contractSeq }}</u></b></router-link>
            </vs-td>
            <vs-td>
              <div style="display: flex; align-items: center;">
                <span>{{ contractName }}</span>
              </div>
            </vs-td>
            <vs-td>
              {{ loan.agingNumber }}
            </vs-td>
            <vs-td>
              {{ loan.outstandingAmountRemain | numberFormat }}
            </vs-td>
            <vs-td>
              {{ loan.outstandingBalanceRemain - loan.outstandingAmountRemain | numberFormat }}
            </vs-td>
            <vs-td>
              {{ loan.accruedFeeRemain | numberFormat }}
            </vs-td>
            <vs-td>
              {{ loan.accruedPenaltyRemain | numberFormat }}
            </vs-td>
            <vs-td>
              <div class="vx-col w-full flex justify-end gap-1">
                <vx-tooltip text="บันทึกการโทร">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-phone-call"
                             @click="onPressedActiveCallHistoryModal(id, contractNo, contractName)"
                             v-if="visibilityAdd(callHistoriesReceivedBy)">
                  </vs-button>
                </vx-tooltip>

                <vx-tooltip text="รับงาน">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-check"
                             @click="onPressedReceiveCallHistory(id)"
                             v-if="visibilityReceive(callHistoriesReceivedBy)">
                  </vs-button>
                </vx-tooltip>

                <vx-tooltip text="ยกเลิกรับงานการโทร">
                  <vs-button
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-x-circle"
                    class="btn-icon"
                    @click="onPressedUnReceiveCallHistory(id)" v-if="visibilityUnReceive(callHistoriesReceivedBy)"
                  />
                </vx-tooltip>
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vs-popup
      :active.sync="callHistoryModal.active"
      :title="callHistoryModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <vs-textarea v-model="callHistoryModal.remark" rows="5"/>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddCallHistory">บันทึก</vs-button>
        <vs-button color="danger" @click="callHistoryModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
    <vs-popup
      :active.sync="receiveManyModal.active"
      title="รับงานหลายรายการ"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-full">
                <validation-provider name="ผู้รับมอบหมายงาน" rules="required" v-slot="{ errors }">
                  <label class="vs-input--label">ผู้รับมอบหมายงาน*</label>
                  <v-select v-model="receiveManyModal.user" :clearable="true" :options="userOptions" name="user"
                            :reduce="res => res.value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="จำนวนงาน" rules="required" v-slot="{ errors }">
                  <label class="text-sm">จำนวนงาน*</label>
                  <vs-input type="number" class="input w-1/2" v-model="receiveManyModal.number"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptReceivedByIds">บันทึก</vs-button>
        <vs-button color="danger" @click="receiveManyModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {ValidationProvider} from "vee-validate";
import {createNamespacedHelpers, mapGetters, mapState} from 'vuex'
import CustomPopup from '@/views/components/custom/Popup'
import {INotiCallExActionType, IStatus} from "@/constants/interface";

const {mapActions: mapUserActions} = createNamespacedHelpers("User");
const {mapActions: mapNotificationActions, mapState: mapNotificationState} = createNamespacedHelpers('Notification')
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  components: {
    CustomPopup,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      callHistoryModal: {
        active: false,
        title: "เพิ่มข้อมูลการโทร",
        remark: "",
        contractId: null
      },
      receiveManyModal: {
        active: false,
        number: 0,
        user: null,
      },
      filteredUsers: [],
      maxOptions: 10,
      debounceTime: 500,
    }
  },
  async created() {
    await this.loadNotificationContractsCallEx();
    await this.loadOptions();
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapNotificationState(['status', 'notificationContractsCallEx']),
    ...mapAccountingFields(['contractDetail', 'contractDetailCallHistories']),
    ...mapGetters({
      userOptions: "User/userOptions",
    }),
    IStatus() {
      return IStatus
    },
    _notificationContractsCallEx: function () {
      if (this.notificationContractsCallEx.length > 0) {
        return this.notificationContractsCallEx
      }
      return this.notificationContractsCallEx
    },
    description: function () {
      const vm = this
      if (vm.$route.params.action === INotiCallExActionType.ntfAll) {
        return `รายการทั้งหมด ${vm._notificationContractsCallEx.length} รายการ`
      } else if (vm.$route.params.action === INotiCallExActionType.inProsecution) {
        return `รายการทั้งหมดที่อยู่ระหว่างดำเนินคดี ${vm._notificationContractsCallEx.length} รายการ`
      } else if (vm.$route.params.action === INotiCallExActionType.unassigned) {
        return `รายการทั้งหมดที่ยังไม่ได้มอบหมาย ${vm._notificationContractsCallEx.length} รายการ`
      } else if (vm.$route.params.action === INotiCallExActionType.assignedByUser) {
        if (vm.notificationContractsCallEx.length === 0) {
          return "ไม่มีรายการที่มอบหมายให้ผู้ใช้คนนี้"
        }
        const assignedUser = vm.notificationContractsCallEx[0].callHistoriesReceivedBy.fullName
        return `รายการทั้งหมดทของ ${assignedUser} จำนวน ${vm._notificationContractsCallEx.length} รายการ`
      }
    }
  },
  methods: {
    ...mapNotificationActions(['getNotificationContractsCallEx']),
    ...mapAccountingActions([
      'createCallHistory',
      'callHistoriesReceived',
      'callHistoriesUnReceived',
      'callHistoriesUnReceivedByUserId',
      'callHistoriesReceivedByIds',
      'callHistoriesUnReceivedAll'
    ]),
    ...mapUserActions([
      "getUserOptions",
    ]),
    onSearchUser(searchText) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.userOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalMatched = matched.length;
        this.filteredUsers = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    async loadNotificationContractsCallEx() {
      const vm = this
      const {getNotificationContractsCallEx} = vm;
      await getNotificationContractsCallEx({
        action: vm.$route.params.action,
        userId: vm.$route.params.userId,
      })
    },
    async loadOptions() {
      const vm = this;
      const {
        userOptions,
      } = vm;
      const {
        getUserOptions,
      } = vm;
      if (userOptions.length === 0) await getUserOptions();

      vm.onSearchUser('');
    },
    async onPressedReceiveCallHistory(contractId) {
      await this.callHistoriesReceived({
        contractId,
      })
      await this.loadNotificationContractsCallEx();
    },
    async onPressedUnReceiveCallHistory(contractId) {
      const vm = this
      const {callHistoriesUnReceived} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการยกเลิกการรับงาน',
        text: 'คุณต้องการยกเลิกการรับงานนี้ใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await callHistoriesUnReceived({
            contractId,
          })
          await this.loadNotificationContractsCallEx();
        }
      })
    },
    async onPressedUnReceiveCallHistoryByUserId() {
      const vm = this
      const userId = this.$route.params.userId;
      const {callHistoriesUnReceivedByUserId} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการยกเลิกการรับงานทั้งหมดของคุณ',
        text: 'คุณต้องการยกเลิกการรับงานทั้งหมดของคุณใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await callHistoriesUnReceivedByUserId({
            userId,
          })
          await this.loadNotificationContractsCallEx();
        }
      })
    },
    async onPressedUnReceivedAllCallHistory() {
      const vm = this
      const userId = this.$route.params.userId;
      const {callHistoriesUnReceivedAll} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการยกเลิกการรับงานทั้งหมด',
        text: 'คุณต้องการยกเลิกการรับงานทั้งหมดใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await callHistoriesUnReceivedAll({
            userId,
          })
          await this.loadNotificationContractsCallEx();
        }
      })
    },
    async onPressedActiveCallHistoryModal(contractId, contractNo, contractName) {
      this.callHistoryModal = {
        title: `เพิ่มข้อมูลการโทร :  ${contractNo} ${contractName}`,
        active: true,
        remark: "",
        contractId: contractId
      }
    },
    async onPressedActiveReceiveManyModal() {
      this.receiveManyModal = {
        active: true,
        user: null,
        number: 0,
      }
    },
    async onPressedAcceptReceivedByIds() {
      const vm = this
      const {callHistoriesReceivedByIds} = vm;
      const ids = this.getContractIds(this._notificationContractsCallEx, Number(vm.receiveManyModal.number));
      await callHistoriesReceivedByIds({
        userId: vm.receiveManyModal.user,
        ids,
      })
      vm.receiveManyModal = {
        active: false,
        user: null,
        number: 0,
      }
      await this.loadNotificationContractsCallEx();
    },
    async onPressedAcceptAddCallHistory() {
      const vm = this
      const {createCallHistory} = vm;
      await createCallHistory({
        contractId: vm.callHistoryModal.contractId,
        form: {
          remark: vm.callHistoryModal.remark,
        }
      })
      vm.callHistoryModal = {
        active: false,
        title: "เพิ่มข้อมูลการโทร",
        remark: "",
        contractId: null
      }
      await this.loadNotificationContractsCallEx();
    },
    getContractIds(data, limit = 10) {
      const shuffled = [...data].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, limit).map(item => item.id);
    },
    visibilityReceiveMany() {
      const action = this.$route.params.action
      return action === INotiCallExActionType.unassigned && this._notificationContractsCallEx.length > 0
    },
    visibilityUnReceiveByUserId() {
      const userId = this.$route.params.userId;
      return this.currentUser.id === userId && this._notificationContractsCallEx.length > 0 && this.$route.params.action === INotiCallExActionType.assignedByUser
    },
    visibilityUnReceivedAll() {
      return this.$route.params.action === INotiCallExActionType.unassigned
    },
    visibilityAdd(callHistoriesReceivedBy) {
      if (!callHistoriesReceivedBy) return false
      const action = this.$route.params.action
      return this.currentUser.id === callHistoriesReceivedBy.id && action === INotiCallExActionType.assignedByUser
    },
    visibilityReceive(callHistoriesReceivedBy) {
      if (callHistoriesReceivedBy) return false
      const action = this.$route.params.action
      return action === INotiCallExActionType.unassigned
    },
    visibilityUnReceive(callHistoriesReceivedBy) {
      if (!callHistoriesReceivedBy) return false
      const action = this.$route.params.action
      return this.currentUser.id === callHistoriesReceivedBy.id && action === INotiCallExActionType.assignedByUser
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
